import * as React from 'react';

type Props = {
  className?: string;
};

const PinFilledIcon: React.FC<Props> = ({ className }) => (
  <svg
    className={className}
    overflow="visible"
    width="17px"
    height="25px"
    viewBox="0 0 17 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M8.2135195,0.763584608 C12.6816046,0.763584608 16.3199025,4.40188248 16.3199025,8.86996759 C16.3199025,12.8274144 14.2773493,14.9976272 12.1071365,18.5082655 L8.2135195,24.7635846 L4.31990248,18.5082655 C2.14968972,14.9976272 0.107136526,12.8274144 0.107136526,8.86996759 C0.107136526,4.40188248 3.7454344,0.763584608 8.2135195,0.763584608 Z M8.2135195,4.08273354 C5.7241578,4.08273354 3.7454344,6.12528674 3.7454344,8.55081865 C3.7454344,11.0401804 5.7241578,13.0189038 8.2135195,13.0189038 C10.7028812,13.0189038 12.6816046,11.0401804 12.6816046,8.55081865 C12.6816046,6.12528674 10.7028812,4.08273354 8.2135195,4.08273354 Z"
        fill="#FFFFFF"
      />
    </g>
  </svg>
);

export default PinFilledIcon;
